import { ErrorHandler, Injectable } from '@angular/core';
import { HttpDevToolsService } from './http-dev-tools.service';

@Injectable()
export class HttpDevToolsErrorHandler implements ErrorHandler {
  constructor(private readonly httpDevTools: HttpDevToolsService) {}

  handleError(error: unknown): void {
    this.httpDevTools.captureException('angular.error-handler', error);
    console.error(error);
  }
}
